/**
 * 電柱リンク (電柱ペア)
 */
export class PoleLink {
  /**
   * コンストラクタ
   */
  constructor(pole1st, pole2nd) {
    this.pole1st = pole1st || null;
    this.pole2nd = pole2nd || null;
  }

  /**
   * 描画可否判定
   */
  drawable() {
    return this.pole1st?.drawable()
        && this.pole2nd?.drawable();
  }

  /**
   * 電柱ペア未設定判定 - 両方の電柱とも未設定
   */
  empty() {
    return !this.pole1st && !this.pole2nd;
  }

  /**
   * 電柱ペア設定判定 - 両方の電柱が設定済
   */
  hasBoth() {
    return this.pole1st && this.pole2nd;
  }

  /**
   * 電柱ペアの先頭を取得
   */
  firstOne() {
    return this.pole1st ?? this.pole2nd ?? null;
  }

  /**
   * 電柱ペアの片方を取得
   *
   * - 片方のみ設定の場合にそれを返す
   * - 両方とも設定の場合はヌルを返す
   */
  onlyOne() {
    return this.hasBoth()
        ? null
        : this.firstOne();
  }

  /**
   * 電柱ペア入れ替え
   */
  reverse() {
    return new PoleLink(this.pole2nd, this.pole1st);
  }

  /**
   * 同一判定
   */
  same(other) {
    if (!other) return false;

    // 両方とも未設定なら一致
    if (this.empty() && other.empty()) {
      return true;
    }

    // 電柱ペア一致判定
    const other1st = other.pole1st;
    const other2nd = other.pole2nd;
    if (this.pole1st?.same(other1st) && this.pole2nd?.same(other2nd)) {
      return true;
    }

    // ペアを入れ替えて判定
    const reverse = this.reverse();
    if (reverse.pole1st?.same(other1st) && reverse.pole2nd?.same(other2nd)) {
      return true;
    }
    return false;
  }

  /** キー */
  key() {
    return [
      this.pole1st?.key() ?? '',
      this.pole2nd?.key() ?? '',
    ].join('/');
  }

  /** 文字列化 */
  toString() {
    return [
      this.pole1st,
      this.pole2nd,
    ].filter(Boolean).join(', ');
  }

  /**
   * ファクトリーメソッド
   */
  static of(pole1st, pole2nd) {
    return (pole1st || pole2nd)
        ? new PoleLink(pole1st, pole2nd)
        : null;
  }
}

// デフォルトエクスポート
export default PoleLink;
